import { graphql, OptionProps } from 'react-apollo';
import {
  ExchangeWorkingHoursQuery,
  ExchangeWorkingHoursQuery_stocksRemote_workingHours,
} from './__generated__/ExchangeWorkingHoursQuery';
import * as query from './query.gql';

export type WorkingHours = Partial<ExchangeWorkingHoursQuery_stocksRemote_workingHours> & {
  refetchWorkingHours?: () => void;
};

const responseToProps = ({ data }: OptionProps<{}, ExchangeWorkingHoursQuery>): WorkingHours => {
  if (!data || !data.stocksRemote || !data.stocksRemote.workingHours) {
    return {};
  }
  return {
    ...data.stocksRemote.workingHours,
    refetchWorkingHours: data.refetch,
  };
};

export const workingHoursHoc = graphql<{}, ExchangeWorkingHoursQuery, {}, WorkingHours>(query, {
  options: {
    fetchPolicy: 'cache-and-network',
  },
  props: responseToProps,
});
